module.exports = __webpack_public_path__ + "img/A.e5c85a72.png";